import React, {useEffect, useRef, useState} from "react";
import Carousel from "../../classes/Carousel";
import { Link } from "react-router-dom";


const ComicCarousel = ({children, setCurrentSlide, imageArr, anchorWrap, excludeArrows, timer}) => {
    const [carouselArr, setCarouselArr] = useState([]);
    const [selectedCarousel, setSelectedCarousel] = useState([]);
    const carousel = useRef(new Carousel());



    useEffect(() => {
        if(imageArr.length > 0) {
            imageArr.forEach(svg => {
                carousel.current.add(svg);
            });
            carousel.current.getCarousel(setCarouselArr, setSelectedCarousel);
        }
        
        let interval = 0;
        if(timer) {
            interval = setInterval(() => {
                carousel.current.previous(); 
                carousel.current.getCarousel(setCarouselArr, setSelectedCarousel);
                
            }, timer);
        }

        return (() => {
            if (timer) {
                clearInterval(interval);
            }
        })
    }, []);

    useEffect(() => {
        console.log("reset");
        
        if(selectedCarousel && setCurrentSlide && selectedCarousel.content !== setCurrentSlide){
            setCurrentSlide(selectedCarousel.content)
        }
    }, [selectedCarousel]);

    
    return (
        <div className="carouselContainer ">
            {/* Printing out img's with(out) anchor */}
            <div className="carouselContentContainer">
                {carouselArr.length > 0 && carouselArr.map((comic, i) => {
                    if(anchorWrap){
                        return (
                            <Link>
                                <comic.content.htmlType {...comic.content.htmlInfo} className={comic.content.htmlInfo.className + " " + ((selectedCarousel.position === comic.position) ? "comicBookSelected" : "" )} />
                            </Link>
                        )   
                    }

                    // return <img src={comic.content.svg} alt={comic.content.alt} className={((selectedCarousel.position === comic.position) ? "comicBookSelected" : "" )} onClick={(e) => {e.preventDefault(); e.stopPropagation(); carousel.current.shiftTo(comic.position); carousel.current.getCarousel(setCarouselArr, setSelectedCarousel);}} />
                    return <comic.content.htmlType {...comic.content.htmlInfo} className={comic.content.htmlInfo.className + " " + ((selectedCarousel.position === comic.position) ? "comicBookSelected" : "" )} />;
                })}
            </div>

            {/* wrapper for navigation elements like circles/arrows */}
            <div className='comicCarouselButtonWrapper flex flexCenter'>
                { !excludeArrows &&
                    <div className="leftArrow" onClick={() => {
                        console.log(carouselArr);
                        carousel.current.next();
                        carousel.current.getCarousel(setCarouselArr, setSelectedCarousel);
                    }}></div>
                }

                {carouselArr.length > 0 && carouselArr.map((comic, i) => {
                    return <div className={"grayCircle " + ((selectedCarousel.position === carouselArr.length - i) ? "comicSelected" : "" )} onClick={() => {
                        carousel.current.shiftTo(carouselArr.length - i);
                        carousel.current.getCarousel(setCarouselArr, setSelectedCarousel);
                    }}></div>
                })}

                { !excludeArrows &&
                    <div className="rightArrow" onClick={() => {
                        console.log(carouselArr);
                        carousel.current.previous();
                        carousel.current.getCarousel(setCarouselArr, setSelectedCarousel);
                    }}></div>
                }
            </div>
        </div>
    );
};

export default ComicCarousel;